import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '😅️',
    subtitle: 'pages.onboarding.mistakesQuestion.answer1Subtitle',
    title: 'pages.onboarding.mistakesQuestion.answer1',
  },
  {
    emoji: '🙂',
    subtitle: 'pages.onboarding.mistakesQuestion.answer2Subtitle',
    title: 'pages.onboarding.mistakesQuestion.answer2',
  },
  {
    emoji: '😎',
    subtitle: 'pages.onboarding.mistakesQuestion.answer3Subtitle',
    title: 'pages.onboarding.mistakesQuestion.answer3',
  },
  {
    emoji: '🔥',
    subtitle: 'pages.onboarding.mistakesQuestion.answer4Subtitle',
    title: 'pages.onboarding.mistakesQuestion.answer4',
  },
]

export default function MistakesQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      subtitle="pages.onboarding.mistakesQuestion.subtitle"
      title="pages.onboarding.mistakesQuestion.title"
    />
  )
}
